export const roundToTwoDecimals = (value: number) => {
  return Math.round(value * 100) / 100;
};
